import { Injectable, Inject } from '@angular/core';
import { ApiService } from '@veritas-shared/services/api.service';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { MenuDynamicBody, MenuOutput } from '../models/menu-output';
import { ToastService } from '@veritas-shared/services/toast.service';
import { WaitService } from '@veritas-shared/services/wait.service';
import { CommonHelper } from '@veritas-shared/helpers/common.helper';
import { ToastService as BeanToastService } from "bean-notification";

@Injectable({
  providedIn: 'root'
})
export class MenuService extends ApiService  {
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    toastService: ToastService,
    waitService: WaitService,
    commonHelper: CommonHelper,
    newToastService: BeanToastService
  ) {
    super(http, baseUrl, toastService, waitService, commonHelper, newToastService);
  }

  public getMenu(): Observable<MenuOutput> {
    return this.getBase<MenuOutput>('api/menu');
  }

  public getDynamicBody = (childId: number): Observable<MenuDynamicBody> => {
    return this.getBase<MenuDynamicBody>(`api/menu/${childId}`);
  }
}
